import { Modal } from "antd"
import { useState } from "react"
import LabeledSwitch from "../common/LabeledSwitch"
import VSpace from "../common/VSpace"

export type Props = {
  open: boolean
  onConfirm: (update: boolean) => void
  onCancel: () => void
  loading: boolean
}
const UpdateItemPricingModal = ({ open, onConfirm, onCancel, loading }: Props) => {
  const [update, setUpdate] = useState(false)

  return <Modal
    open={open}
    onOk={() => onConfirm(update)}
    onCancel={onCancel}
    confirmLoading={loading}
    title="Update Item Pricing"
    okText="Apply"
  >
    <VSpace>
      <p>Do you want to update the item pricing for all unsold jobs assigned to this budget?</p>
      <LabeledSwitch value={update} onChange={() => setUpdate(!update)} label="Yes, update all unsold jobs already assigned to this budget" />
      <LabeledSwitch value={!update} onChange={() => setUpdate(!update)} label="No, only use these changes for new jobs from here on out" />
    </VSpace>
  </Modal>
}

export default UpdateItemPricingModal
